import { X } from "lucide-react";

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  ariaLabel = "Close",
}) => {
  return (
    <button
      onClick={onClick}
      className={`absolute top-2 right-2 text-gray-700 hover:text-gray-900 `}
      aria-label={ariaLabel}
    >
      <X />
    </button>
  );
};

export default CloseButton;
